import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "disabled", "onSelect", "selected", "value"];
import React from 'react';
import withTheme from '../../theme/withTheme';
import { YearText } from './styles';
var Year = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var children = props.children,
    disabled = props.disabled,
    onSelect = props.onSelect,
    selected = props.selected,
    value = props.value,
    other = _objectWithoutProperties(props, _excluded);
  var onSelectHandler = React.useCallback(function () {
    return onSelect(value);
  }, [onSelect, value]);
  return /*#__PURE__*/React.createElement(YearText, _extends({
    role: "button",
    disabled: disabled,
    tabIndex: disabled ? -1 : 0,
    onClick: onSelectHandler,
    onKeyPress: onSelectHandler,
    selected: selected,
    ref: ref
  }, other), children);
});
export default withTheme(Year);